import { get, post, patch, del } from "../../utils/axiosInstance";

const BASE_URL = "/rest/shipments";

export const fetchOrders = (page, orderId = null, market = null, status = null, date = null, isPlantUser = true) => {
  let url = `${BASE_URL}/orders/?page=${page}`;
  if (orderId) url += `&id=${orderId}`;
  if (market) url += `&market=${market}`;
  if (date) {
    if (isPlantUser) url += `&sent_to_market_date=${date}`;
    else url += `&delivery_date=${date}`;
  }
  if (status) url += `&status=${status}`;
  return get(url);
};

export const fetchOrderDetail = (id) => {
  const url = `${BASE_URL}/orders/${id}/`;
  return get(url);
};

export const createOrder = () => {
  const url = `${BASE_URL}/orders/`;
  return post(url);
};

export const fetchOrderDuplicate = (id) => {
  const url = `${BASE_URL}/orders/${id}/duplicate/`;
  return post(url);
};

export const fetchBackOrderDetail = (id) => {
  const url = `${BASE_URL}/orders/${id}/back_order_summary/`;
  return get(url);
};

export const updateDeliveryDate = (id, data) => {
  const url = `${BASE_URL}/orders/${id}/`;
  return patch(url, data);
};

export const addItemToMarketOrder = (id, data) => {
  const url = `${BASE_URL}/orders/${id}/add_item/`;
  return post(url, data);
};

export const deleteItemFromMarketOrder = (id) => {
  const url = `${BASE_URL}/order_items/${id}/`;
  return del(url);
};

export const updateItemInMarketOrder = (id, data) => {
  const url = `${BASE_URL}/order_items/${id}/`;
  return patch(url, data);
};

export const sendMarketOrder = (id) => {
  const url = `${BASE_URL}/orders/${id}/send_order/`;
  return post(url);
};

export const changeBackOrderStatus = (id, value) => {
  const url = `${BASE_URL}/order_items/${id}/change_back_order_status/`;
  return post(url, { in_back_order: value });
};

export const changeItemCompletedNotBackOrderStatus = (id, value) => {
  const url = `${BASE_URL}/order_items/${id}/change_item_completed_not_back_order_status/`;
  return post(url, { completed_not_back_order: value });
};

export const setInventoryReceived = (orderId, inventoryId, value, format, times, from_scanner) => {
  const url = `${BASE_URL}/orders/${orderId}/set_inventory_received/`;
  return post(url, {inventory_id: inventoryId, value, format, times, from_scanner});
};

export const completeOrderReceived = (orderId) => {
  const url = `${BASE_URL}/orders/${orderId}/complete_receive/`;
  return post(url);
};

export const getProductionList = () => {
  const url = `${BASE_URL}/orders/get_production_list/`;
  return get(url, { responseType: "arraybuffer" });
};

export const deleteMarketOrder = (id) => {
  const url = `${BASE_URL}/orders/${id}/`;
  return del(url);
};

export const changeMarketOrderStatusFromReceivedToShipped = (id) => {
  const url = `${BASE_URL}/orders/${id}/change_status_from_received_to_shipped/`;
  return post(url);
};

export const changeItemForSubstitute = (id, data) => {
  const url = `${BASE_URL}/orders/${id}/change_item_for_substitute/`;
  return post(url, data);
};
